import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
import { HttpParams} from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})
export class BankingDayService extends BaseRestService{

  readonly BANKING_DAY_API_URL: string = environment.apiUri + '/banking-day';

  getStatus(): Observable<any> {
    return this.httpClient.get(this.BANKING_DAY_API_URL + '/status' ,
        { headers: this.headers });
  }

  getBusinessDay(): Observable<any> {
    return this.httpClient.get(this.BANKING_DAY_API_URL + '/business-day' ,
        { headers: this.headers });
  }

  setBusinessDay(businessDay): Observable<any> {
    return this.httpClient.post(this.BANKING_DAY_API_URL + '/business-day',
        null,
        {
          params: new HttpParams().set('businessDay', businessDay),
          headers: this.headers
        });
  }

  setUserException(data): Observable<any> {
    return this.httpClient.post(this.BANKING_DAY_API_URL + '/business-day/range',
        data,
        {headers: this.headers});
  }

  deleteUserException(data): Observable<any> {
    return this.httpClient.put(this.BANKING_DAY_API_URL + '/business-day/range',
        data,
        {headers: this.headers});
  }

  changeStatus(status): Observable<any> {
    return this.httpClient.post(this.BANKING_DAY_API_URL + '/change-day-status/' + status,
        JSON.stringify(status),
        { headers: this.headers });
  }

}
